import { render, staticRenderFns } from "./CostRecalculationModal.vue?vue&type=template&id=45c6d441&scoped=true"
import script from "./CostRecalculationModal.vue?vue&type=script&lang=js"
export * from "./CostRecalculationModal.vue?vue&type=script&lang=js"
import style0 from "./CostRecalculationModal.vue?vue&type=style&index=0&id=45c6d441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6d441",
  null
  
)

export default component.exports